var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStoreActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    fill: "none",
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C1D6FF",
    d: "M3.614 1.367H15.190000000000001V7.832H3.614zM3.614 11.232H15.808V18.08H3.614z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1AC1B1",
    d: "M.3 8.043h18.26l-1.296 1.99H1.466L.3 8.043z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#628BF5",
    d: "M16.857 1.644V0H1.605v1.644L0 7.397v.941c0 .857.496 1.62 1.204 2.002v7.74h3.21v-6.574h3.212v6.575h9.632v-7.574c.914-.276 1.605-1.157 1.605-2.169v-.941l-2.006-5.753zM2.207 9.777c-.661 0-1.404-.544-1.404-1.559h2.81c0 1.014-.743 1.559-1.406 1.559zm11.439-8.133l.802 5.753H11.64l-.401-5.753h2.408zm.802 6.574c0 1.007-.736 1.559-1.404 1.559-.683 0-1.405-.565-1.405-1.559h2.81zM5.82 9.777c-.662 0-1.405-.544-1.405-1.559h2.81c0 1.014-.743 1.559-1.405 1.559zm1.404-2.38h-2.81l.804-5.753h2.408l-.402 5.753zm.803.821h2.81c0 1.014-.743 1.559-1.405 1.559s-1.405-.544-1.405-1.559zm7.626 8.219H9.23v-4.931h6.421v4.93zm1.003-6.66c-.683 0-1.405-.565-1.405-1.559h2.81c0 1.007-.737 1.559-1.405 1.559z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreActive);
export default __webpack_public_path__ + "static/media/store-active.5970bb326f77a926b5fc492becfcb72d.svg";
export { ForwardRef as ReactComponent };